import { render } from "./SupportSimp.vue?vue&type=template&id=4a88a876"
import script from "./SupportSimp.vue?vue&type=script&lang=js"
export * from "./SupportSimp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__